(function () {
    angular.module('invesfleet')
        .directive('scrollList', scrollList);

    scrollList.$inject = ['$timeout'];

    function scrollList($timeout) {

        return {
            restrict: 'A',
            scope: {
                control: '='
            },
            link: function (scope, element, attrs) {
                scope.control.goTo = function (index) {

                    $timeout(function () {
                        var list = element[0];
                        var item = list.children[index];

                        //If we need to scroll up to find the item
                        if (item.offsetTop < list.scrollTop) {
                            list.scrollTop = item.offsetTop;
                        }

                        //If we need to scroll down to find the item
                        if (item.offsetTop + item.offsetHeight > list.scrollTop + list.clientHeight) {
                            list.scrollTop = item.offsetTop + item.offsetHeight - list.clientHeight;

                        }

                    });
                };

            }
        };
    }
})();